export default {
  set(state, { data }) {
    state.lockers = data;
  },
  show(state, { data }) {
    state.locker = data;
  },
  getPage(state, { data }) {
    state.page = data
  }
}